import * as bowser from 'bowser';
import * as _ from 'lodash';
import { SessionStorageService } from 'Src/ng2/shared/services/web-storage/session-storage/session-storage.service';
import { SpinnerToggle } from '../../../../ng2/shared/constants/spinner.constant';
import { UserAgentDetection } from '../../../../ng2/shared/constants/user-agent.constant';

export class UserAgent {
  static $inject: string[] = ['ConfirmationModal', 'SessionStorageService'];

  constructor(private ConfirmationModal, private sessionStorageService: SessionStorageService) {}

  checkBrowserType() {
    const alertUser = _.isNull(this.sessionStorageService.getItem(UserAgentDetection.BROWSER_CHECK_SESSION_FLAG));
    const isSupportedBrowser = bowser.name.toLowerCase() === UserAgentDetection.SUPPORTED_BROWSER;
    // this method is more reliant than just using a version number check
    // tslint:disable-next-line:max-line-length
    const isSupportedVersion = bowser.check(
      { chrome: UserAgentDetection.MIN_SUPPORTED_VERSION },
      true,
      window.navigator.userAgent,
    );

    if (alertUser) {
      // display warning only if the user hasn't been warned before
      if (!isSupportedBrowser) {
        const title = 'Warning: Please use Chrome browser';
        const message =
          `The Data Portal is optimized for Google Chrome browser. Your current browser is ` +
          `unsupported; if you continue, features may not work correctly.`;
        return this.ConfirmationModal.show(title, message, 'I understand the RISK!', false).then(x => {
          this.sessionStorageService.setItem(UserAgentDetection.BROWSER_CHECK_SESSION_FLAG, true);
          this.sessionStorageService.setItem(SpinnerToggle.PREVENT_SPINNER, true);
        });
      } else if (!isSupportedVersion) {
        this.sessionStorageService.setItem(UserAgentDetection.BROWSER_CHECK_SESSION_FLAG, true);
        const title = 'Warning: Please update your Chrome browser';
        const message =
          `The Data Portal is optimized for Google Chrome version ` +
          UserAgentDetection.MIN_SUPPORTED_VERSION +
          ` and above.  You\'re currently using version ` +
          bowser.version +
          `. If you ` +
          `continue, features may not work correctly.`;
        return this.ConfirmationModal.show(title, message, 'I understand the RISK!', false).then(x => {
          this.sessionStorageService.setItem(SpinnerToggle.PREVENT_SPINNER, true);
        });
      } else {
        this.sessionStorageService.setItem(SpinnerToggle.PREVENT_SPINNER, true);
      }
    }
  }
}
